import DeploymentPage from './DeploymentPage';

export default DeploymentPage;
